import { clsx } from 'clsx';
import React from 'react';
import { isResponsiveValue } from '../hooks/useResponsiveValue.js';
import { defaultSxProp } from '../utils/defaultSxProp.js';
import { BoxWithFallback } from '../internal/components/BoxWithFallback.js';
import classes from './Avatar.module.css.js';
import { jsx } from 'react/jsx-runtime';

const DEFAULT_AVATAR_SIZE = 20;
const Avatar = /*#__PURE__*/React.forwardRef(function Avatar({
  alt = '',
  size = DEFAULT_AVATAR_SIZE,
  square = false,
  sx: sxProp = defaultSxProp,
  className,
  style,
  ...rest
}, ref) {
  const isResponsive = isResponsiveValue(size);
  const cssSizeVars = {};
  if (isResponsive) {
    for (const [key, value] of Object.entries(size)) {
      cssSizeVars[`--avatarSize-${key}`] = `${value}px`;
    }
  } else {
    cssSizeVars['--avatarSize-regular'] = `${size}px`;
  }
  return /*#__PURE__*/jsx(BoxWithFallback, {
    as: "img",
    "data-component": "Avatar",
    className: clsx(className, classes.Avatar),
    ref: ref,
    alt: alt,
    "data-responsive": isResponsive ? '' : undefined,
    "data-square": square ? '' : undefined,
    width: isResponsive ? undefined : size,
    height: isResponsive ? undefined : size,
    style: style ? {
      ...cssSizeVars,
      ...style
    } : cssSizeVars,
    sx: sxProp,
    ...rest
  });
});
if (process.env.NODE_ENV !== "production") {
  Avatar.displayName = 'Avatar';
}

export { DEFAULT_AVATAR_SIZE, Avatar as default };
